import { CART_CONSTANTS } from '../constants/ui';
import { QUERY_PARAMS as ALGOLIA_QUERY_PARAMS } from '../constants/algolia';

import { CartProductType } from '../types/state/reducers/cartReducersTypes';
import { NextRouter } from 'next/router';

import httpHelpers from './http';

// TODO test
const filterOutDiscountItem = (product: CartProductType): boolean => {
  return product.name !== CART_CONSTANTS.BUNDLE_DISCOUNT_PRODUCT_NAME;
};

// TODO test
const buildCheckoutLink = (router: NextRouter): string => {
  const queryId = router.query[ALGOLIA_QUERY_PARAMS.QUERY_ID];
  const queryParams = {};
  if (queryId) queryParams[ALGOLIA_QUERY_PARAMS.QUERY_ID] = queryId;
  const { mapQueryParams } = httpHelpers;
  return mapQueryParams('/checkout', queryParams);
}

const cartHelpers = {
  filterOutDiscountItem,
  buildCheckoutLink,
};

export default cartHelpers;
